export function calcular(quantidade: number, rows: any[]): any[] {
  const calc = rows.map((i) => {
    return {
      ...i,
      qtd_total: quantidade * i.qtd_producao,
      val_custo_producao_total: quantidade * i.val_custo_rep,
    };
  });
  return calc;
}

export function calcTotalizadores(rows: any[]): any {
  return rows.reduce(
    (acc, item) => {
      acc.tot_custo_producao += item.val_custo_producao_total;
      acc.tot_qtd_producao += item.qtd_total;
      return acc;
    },
    { tot_custo_producao: 0, tot_qtd_producao: 0 },
  );
}

export function calcTotalizadoresOnRowClick(rows: any[]): any {
  return rows.reduce(
    (acc, item) => {
      acc.tot_custo_producao += item.tot_custo_producao;
      acc.tot_qtd_producao += item.tot_qtd_producao;
      return acc;
    },
    { tot_custo_producao: 0, tot_qtd_producao: 0 },
  );
}
